import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Button,
} from '@mui/material';
import {
  History as HistoryIcon,
  Security as SecurityIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import MainLayout from '../../../components/layout/MainLayout';

const LogsIndex: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MainLayout>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 1 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/system-settings')} sx={{ mr: 2 }}>
            Back
          </Button>
          <HistoryIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h4">Logs & Audit</Typography>
        </Box>

        <Typography variant="body1" color="textSecondary" paragraph>
          View detailed logs of user activities and system changes for compliance and security auditing.
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          {/* User Logs Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardActionArea onClick={() => navigate('/system-settings/logs/users')}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 4 }}>
                  <HistoryIcon color="primary" sx={{ fontSize: 48 }} />
                  <Typography variant="h6">User Logs</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    View user login history, data entry actions, and activity tracking.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          {/* System Audit Logs Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardActionArea onClick={() => navigate('/system-settings/logs/audit')}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 4 }}>
                  <SecurityIcon color="secondary" sx={{ fontSize: 48 }} />
                  <Typography variant="h6">System Audit Logs</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    Track system-level changes, role permissions, and configuration updates.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MainLayout>
  );
};

export default LogsIndex;
